<app-reset-password
  #resetPasswordModal
  [modalMessage]=""
  [modalTitle]=""
></app-reset-password>
<div class="row">
  <div
    class="top-bar error-notification"
    style="cursor: pointer"
    *ngIf="app.error && !app.hasError"
  >
    <div class="container">
      <div class="p-1">
        <div class="col-md-2 pull-left">
          <i class="fa-solid fa-ban banIcon"></i>
        </div>
        <div class="col-md-10 pull-right">
          <div class="col-md-12 text-danger text-uppercase">
            {{ app.text.app.error }}
            <div class="close-btn pull-right" (click)="app.hasError = false">
              <i class="fa fa-times"></i>
            </div>
          </div>
          <div class="col-md-12">
            {{ app.text.app.errorOccured }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- *ngIf="app.error && !app.hasError" -->
<div class="row">
  <div
    class="top-bar success success-notification"
    style="cursor: pointer"
    *ngIf="app.hasSuccess"
  >
    <div class="container">
      <div class="p-1">
        <div class="col-md-2 pull-left">
          <i class="fa-solid fa-octagon-check successIcon"></i>
        </div>
        <div class="col-md-10 pull-right">
          <div class="col-md-12 text-success text-uppercase">
            {{ app.text.app.success }}
            <div class="close-btn pull-right" (click)="app.hasSuccess = false">
              <i class="fa fa-times"></i>
            </div>
          </div>
          <div class="col-md-12">
            {{ app.successText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="app-container offset-md-3 col-md-6">
  <div class="card-login contentBody">
    <div class="row p-0">
      <div class="col-md-12">
        <div
          *ngIf="!app.environment.isPortal && !app.environment.isOC"
          class="text-center p-2"
        >
          <img
            *ngIf="app.auth.landing == null"
            class="p-1 m-2 login-image"
            [src]="app.url.auth.logo"
          />
          <img
            *ngIf="app.auth.landing != null"
            class="p-1 m-2 login-image-omp"
            [src]="app.url.auth.landingLogo"
          />
        </div>
        <div *ngIf="app.environment.isPortal" class="text-center p-2">
          <img
            class="p-1 m-2 login-image-omp-reduced-width"
            [src]="app.url.auth.landingLogo"
          />
        </div>
        <div *ngIf="app.environment.isOC" class="text-center p-2">
          <img class="p-3 m-2 login-image" [src]="app.url.auth.ocLogo" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="m-2 p-2 text-center">
        <div class="welcomeText">{{ app.text.auth.welcome }}</div>
        <div class="enterDetailText">{{ app.text.auth.enterDetails }}</div>
      </div>
    </div>
    <div class="row inputRow">
      <div class="col-md-6">
        <form
          class="loginForm"
          [formGroup]="loginForm"
          (ngSubmit)="attemptLogin()"
        >
          <label for="emailInput" class="form-label emailLabel">{{
            app.field.getLabel(app.fieldId.user.email)
          }}</label>
          <div class="input-group mb-2">
            <input
              type="text"
              id="emailInput"
              aria-label="Email"
              class="form-control emailInput"
              [ngClass]="{ redBorder: passwordError }"
              formControlName="email"
            />
          </div>
          <div
            *ngIf="loginForm.controls.email.errors?.email"
            class="loginError"
          >
            {{ app.text.auth.loginEmailError }}
          </div>
          <label for="passwordInput" class="form-label emailLabel">{{
            app.field.getLabel(app.fieldId.user.password)
          }}</label>
          <div class="input-group mb-1">
            <input
              type="password"
              id="passwordInput"
              aria-label="Email"
              class="form-control emailInput"
              [ngClass]="{ redBorder: passwordError }"
              formControlName="password"
            />
          </div>
          <div *ngIf="passwordError">
            <div class="loginError">
              {{ app.text.auth.loginError }}
            </div>
            <div class="loginError">
              {{ app.text.auth.remainingAttempts }} {{ app.auth.loginAttempts }}
            </div>
          </div>
          <div class="controls">
            <button
              type="submit"
              class="btn sendEmailBtn"
              [disabled]="!loginForm.valid || app.auth.loginBtnDisabled"
            >
              {{ app.text.auth.loginButton }}
            </button>
          </div>
        </form>
        <hr />
        <button
          *ngIf="showEntraLogin"
          (click)="entraLogin()"
          class="btn loginMicrosoftBtn"
        >
          <i class="fa-brands fa-microsoft" style="color: #74c0fc"></i>
          {{ app.text.auth.loginButtonMicrosoft }}
        </button>
        <div *ngIf="app.environment.isPortal" class="text-center p-1">
          <span class="sign-alternative p-1">
            {{ app.text.auth.accept }}

            <a
              class="terms fg-pass"
              target="_blank"
              [href]="app.url.footer.terms"
            >
              {{ app.text.footer.terms }}
            </a>
          </span>
        </div>
        <div *ngIf="app.environment.isOC" class="text-center p-1">
          <div class="sign-alternative p-1 mb-2">
            {{ app.text.auth.accept }}

            <a
              class="terms fg-pass fg-pass-alternative"
              target="\_blank"
              [href]="app.url.footer.termsOC"
            >
              {{ app.text.footer.termsOC }}
            </a>

            <div class="p-1">
              {{ app.text.auth.additionalInfoOC }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="text-center m-1 p-1">
            <a
              class="fg-pass"
              [ngClass]="{ 'fg-pass-alternative': app.environment.isOC }"
              (click)="openModal()"
            >
              {{ app.text.resetPassword.forgotPassword }} &nbsp;
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-1">
      <div class="text-center m-1 p-1 mb-5">
        <a
          class="fg-pass"
          [ngClass]="{ 'fg-pass-alternative': app.environment.isOC }"
          [href]="getContactFormURL()"
          target="_blank"
          >{{ app.text.auth.help }}</a
        >
      </div>
    </div>
  </div>
</div>

<div class="app-footer">
  <app-footer></app-footer>
</div>
